import SessionStorage from "./SessionStorage";

export default class SessionPersistentFiltersService {

    constructor(
        readonly storage: SessionStorage<unknown>,
        readonly key: string,
    ) {}

    load() {
        return this.storage.get(this.key);
    }

    save(filter) {
        this.storage.set(this.key, filter);
    }

}
